import React from 'react';
import { Annex6TableColumns } from './Annex6TableRows';
import { TAnnex6BackendRecord } from 'redux/app/annex6/@types';
// import { marpolUtils } from 'redux/app/marpol';
import MARPOLModule from 'redux/app/marpol/operation.types';

function getSignTableRows(record: TAnnex6BackendRecord): Annex6TableColumns[] {
    function getFormattedDate(dateWithTime: string) {
        return dateWithTime;
        // return marpolUtils.getDate(dateWithTime);
    }

    function renderSignatures() {
        if (!record.submittedBy) return null;

        return (
            <h4 className="font-medium leading-9 uppercase">
                RECORDED BY: {renderSubmittedBy()}
                <br />
                {record.editedBy && (
                    <>
                        UPDATED BY: {renderSignatureItem(record.editedBy)}
                        <br />
                    </>
                )}
                VERIFIED BY: {renderVerifiedBy()}
                <br />
                APPROVED BY: {renderApprovedBy()}
            </h4>
        );
    }

    function renderStrikeOffSign() {
        if (!record.strikedBy) return null;
        return (
            <h4 className="font-medium leading-9 uppercase">
                STRUCK OFF BY: {renderSignatureItem(record.strikedBy)}
                <div className="w-full">
                    STRUCK OFF REASON:
                    <span className="ml-1 font-bold text-red-700">
                        {record.strikeOffReason}
                    </span>
                </div>
            </h4>
        );
    }

    function renderSignatureItem(user?: MARPOLModule.RecordUser) {
        if (!user) return 'PENDING';
        const { date, designation, name, staffId } = user;
        return `${name} [${designation}] - ${staffId}
		 on ${getFormattedDate(date)}`;
    }

    function renderSubmittedBy() {
        if (!record.submittedBy) return null;
        const signData = record.submittedBy;
        const isPending = !record.submittedBy;
        if (!signData || isPending) return 'PENDING';
        const { date, designation, name, staffId } = signData;
        return `${name} [${designation}] - ${staffId}
		 on ${getFormattedDate(date)}`;
    }

    function renderVerifiedBy() {
        if (!record.verifiedBy) return null;
        const signData = record.verifiedBy;
        const isPending = !record.verifiedBy;
        if (!signData || isPending) return 'PENDING';
        const { date, designation, name, staffId } = signData;
        return `${name} [${designation}] - ${staffId}`;
    }

    function renderApprovedBy() {
        if (!record.approvedBy) return null;
        const signData = record.approvedBy;
        const isPending = !record.approvedBy;
        if (!signData || isPending) return 'PENDING';
        const { date, designation, name, staffId } = signData;
        return `${name} [${designation}] - ${staffId}
		 on ${getFormattedDate(date)}`;
    }

    return [
        [null, null, null, renderSignatures()],
        [null, null, null, renderStrikeOffSign()],
    ];
}

export default getSignTableRows;
